"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
require("core-js/modules/es6.function.name");
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("el-dialog", {
    attrs: {
      width: "500px",
      title: "添加联系人",
      visible: _vm.dialogVisible,
      "close-on-click-modal": false,
      "append-to-body": ""
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.dialogVisible = $event;
      }
    }
  }, [_c("el-form", {
    ref: "ruleForm",
    attrs: {
      model: _vm.form,
      rules: _vm.rules,
      "label-width": "100px"
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "订单编号"
    }
  }, [_c("el-input", {
    attrs: {
      disabled: ""
    },
    model: {
      value: _vm.tradeNo,
      callback: function callback($$v) {
        _vm.tradeNo = $$v;
      },
      expression: "tradeNo"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "姓名"
    }
  }, [_c("el-input", {
    model: {
      value: _vm.form.name,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "name", $$v);
      },
      expression: "form.name"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "关系"
    }
  }, [_c("el-input", {
    model: {
      value: _vm.form.relation,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "relation", $$v);
      },
      expression: "form.relation"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "电话"
    }
  }, [_c("el-input", {
    model: {
      value: _vm.form.phone,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "phone", $$v);
      },
      expression: "form.phone"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "微信认证"
    }
  }, [_c("el-radio-group", {
    model: {
      value: _vm.form.is_wechar,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "is_wechar", $$v);
      },
      expression: "form.is_wechar"
    }
  }, [_c("el-radio", {
    attrs: {
      label: 1
    }
  }, [_vm._v("是")]), _c("el-radio", {
    attrs: {
      label: 0
    }
  }, [_vm._v("否")])], 1)], 1), _c("el-form-item", {
    attrs: {
      label: "支付宝认证"
    }
  }, [_c("el-radio-group", {
    model: {
      value: _vm.form.is_alipay,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "is_alipay", $$v);
      },
      expression: "form.is_alipay"
    }
  }, [_c("el-radio", {
    attrs: {
      label: 1
    }
  }, [_vm._v("是")]), _c("el-radio", {
    attrs: {
      label: 0
    }
  }, [_vm._v("否")])], 1)], 1)], 1), _c("div", {
    staticClass: "dialog-footer",
    attrs: {
      slot: "footer"
    },
    slot: "footer"
  }, [_c("el-button", {
    attrs: {
      size: "small"
    },
    on: {
      click: function click($event) {
        _vm.dialogVisible = false;
      }
    }
  }, [_vm._v("取 消")]), _c("el-button", {
    attrs: {
      size: "small",
      type: "primary"
    },
    on: {
      click: _vm.submit
    }
  }, [_vm._v("确 定")])], 1)], 1);
};
exports.render = render;
var staticRenderFns = [];
exports.staticRenderFns = staticRenderFns;
render._withStripped = true;